<template>
  <div class="dialog-root" v-loading="loading">
    <div class="container">
      <avue-form ref="formRef" :option="formOption" v-model="formData">
        <template slot="unitPrice">
          <moneyInput
            v-model="formData.unitPrice"
            placeholder="请输入单价"
            :disabled="dialogType == 'view'"
            style="width: 100%"
          />
        </template>
        <template slot="costAmount">
          <moneyInput
            v-model="formData.costAmount"
            placeholder="请输入本期费用"
            :disabled="dialogType == 'view' || formData.meterCategory == 'INCOME_METER'"
            style="width: 100%"
          />
        </template>
      </avue-form>
    </div>
    <!-- 按钮占位区域 -->
    <div class="placeholder" v-if="dialogType != 'view'"></div>
    <!-- 底部操作按钮 -->
    <div class="btn" v-if="dialogType != 'view'">
      <el-button type="primary" size="small" @click="doSave">
        {{ dialogType == 'add' ? '保存' : '修改' }}
      </el-button>
      <el-button size="small" @click="doClose">取消</el-button>
    </div>
  </div>
</template>

<script>
import { getAreaList } from '@/api/meter-management/meter-permission';
import { getDict, getMeterTree } from '@/api/meter-management/index';
import { getDetail, add, update, getSumAmount } from '@/api/meter-management/meter-fee-records';

export default {
  props: ['dialogType', 'rowData'],
  data() {
    return {
      delayTimer: -1,
      loading: false,
      dicDatas: {
        meterTree: {},
        areaCode: [],
        meterType: [],
        meterCategory: [],
      },
      formData: {
        meterId: '',
      },
    };
  },
  computed: {
    formOption() {
      const ret = {
        labelWidth: 100,
        menuBtn: false,
        column: [
          {
            label: '仪表名称',
            prop: 'meterId',
            span: 8,
            disabled: this.dialogType != 'add',
            dicData: this.dicDatas.meterTree,
            type: 'tree',
            props: {
              label: 'name',
              value: 'id',
            },
            rules: [
              {
                required: true,
                message: '请选择仪表名称',
                trigger: 'change',
              },
            ],
          },
          {
            label: '仪表类型',
            prop: 'meterType',
            span: 8,
            disabled: true,
            type: 'select',
            dicData: this.dicDatas.meterType,
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            rules: [
              {
                required: true,
                message: '请选择仪表类型',
                trigger: 'change',
              },
            ],
          },
          {
            label: '仪表类别',
            prop: 'meterCategory',
            span: 8,
            disabled: true,
            type: 'select',
            dicData: this.dicDatas.meterCategory,
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            rules: [
              {
                required: true,
                message: '请选择仪表类别',
                trigger: 'change',
              },
            ],
          },
          {
            label: '管理区域',
            prop: 'areaCode',
            span: 8,
            disabled: true,
            dicData: this.dicDatas.areaCode,
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            type: 'tree',
            rules: [
              {
                required: true,
                message: '请选择管理区域',
                trigger: 'change',
              },
            ],
          },
          {
            label: '本期起码',
            prop: 'startNum',
            value: 0,
            span: 8,
            disabled: true,
            maxlength: 30,
            showWordLimit: true,
            rules: [
              {
                required: true,
                message: '请输入本期起码',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '本期止码',
            prop: 'endNum',
            value: 0,
            span: 8,
            disabled: this.dialogType == 'view',
            rules: [
              {
                required: true,
                message: '请输入本期止码',
                trigger: 'blur',
              },
              {
                pattern: /^-?\d+(\.\d+)?$/,
                message: '请输入数字',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '单价',
            prop: 'unitPrice',
            value: 0,
            span: 8,
            display: this.formData.meterCategory == 'INCOME_METER',
            formslot: true,
            rules: [
              {
                required: true,
                message: '请输入单价',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '本期用量',
            prop: 'useNum',
            value: 0,
            span: 8,
            disabled: true,
            rules: [
              {
                required: true,
                message: '请输入本期用量',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '本期费用',
            prop: 'costAmount',
            value: 0,
            span: 8,
            formslot: true,
            rules: [
              {
                required: true,
                message: '请输入本期费用',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '抄表账期',
            prop: 'meterReadingPeriod',
            span: 8,
            disabled: this.dialogType == 'view',
            type: 'month',
            valueFormat: 'yyyy-MM',
            rules: [
              {
                required: true,
                message: '请选择抄表账期',
                trigger: 'change',
              },
            ],
          },
          {
            label: '抄表日期',
            prop: 'meterReadingDate',
            span: 8,
            disabled: this.dialogType == 'view',
            type: 'date',
            valueFormat: 'yyyy-MM-dd',
            rules: [
              {
                required: true,
                message: '请选择抄表日期',
                trigger: 'change',
              },
            ],
          },
        ],
      };
      return ret;
    },
  },
  watch: {
    'formData.meterId'(newVal, oldVal) {
      if (this.dialogType == 'view' || this.dialogType == 'edit') return;
      if (newVal) {
        let meter = this.findItemById(this.dicDatas.meterTree, newVal);
        this.formData.meterType = meter.meterType;
        this.formData.meterCategory = meter.meterCategory;
        this.formData.areaCode = meter.areaCode;
        this.formData.startNum = meter.lastEndNum || 0;
      } else {
        this.formData.meterType = '';
        this.formData.meterCategory = '';
        this.formData.areaCode = '';
        this.formData.startNum = 0;
      }
      if (newVal && oldVal && newVal != oldVal) {
        this.formData.endNum = 0;
        this.formData.useNum = 0;
        this.formData.costAmount = 0;
      }
    },
    'formData.endNum'(val) {
      if (
        this.formData.meterCategory &&
        val &&
        this.isNumber(val) &&
        this.isNumber(this.formData.startNum)
      ) {
        clearTimeout(this.delayTimer);
        this.delayTimer = setTimeout(() => {
          this.computedCostAmount();
        }, 300);
      } else {
        this.formData.useNum = 0;
        this.formData.costAmount = 0;
      }
    },
    'formData.unitPrice'() {
      clearTimeout(this.delayTimer);
      this.delayTimer = setTimeout(() => {
        this.computedCostAmount();
      }, 300);
    },
  },
  unmounted() {
    clearTimeout(this.delayTimer);
  },
  async created() {
    // 因为表单的配置选项使用的是计算属性，如果是使用dicUrl则每次重新生成值都会触发字典加载，所以这里使用dicData
    await Promise.all([
      getMeterTree(),
      getAreaList(),
      getDict({ code: 'shunt_meter_type' }),
      getDict({ code: 'shunt_meter_category' }),
    ]).then((res) => {
      this.dicDatas.meterTree = res[0].data;
      this.dicDatas.areaCode = res[1].data;
      this.dicDatas.meterType = res[2].data;
      this.dicDatas.meterCategory = res[3].data;
    });
    if (this.dialogType === 'edit' || this.dialogType === 'view') {
      this.getDetail();
    }
  },
  methods: {
    /* 查找树形结构里指定id的节点 */
    findItemById(tree, id) {
      for (let i = 0; i < tree.length; i++) {
        let node = tree[i];
        if (node.id === id) {
          return node;
        }
        if (node.children && node.children.length > 0) {
          let foundItem = this.findItemById(node.children, id);
          if (foundItem) {
            return foundItem;
          }
        }
      }
      return null;
    },
    /* 判断是否为数字 */
    isNumber(value) {
      return /^-?\d+(\.\d+)?$/.test(value);
    },
    /* 计算本期费用和本期用量 */
    computedCostAmount() {
      // 本期用量都需要从后端去获取，并不是单纯的止码-始码，本期费用则需要分情况：支出表需要用户自己输入，收入表从后端取
      if (this.formData.meterCategory == 'INCOME_METER') {
        if (
          this.isNumber(this.formData.unitPrice) &&
          this.isNumber(this.formData.startNum) &&
          this.isNumber(this.formData.endNum)
        ) {
          getSumAmount({
            meterId: this.formData.meterId,
            startNum: this.formData.startNum,
            endNum: this.formData.endNum,
            unitPrice: this.formData.unitPrice,
          }).then(({ data }) => {
            this.formData.costAmount = data.costAmount || 0;
            this.formData.useNum = data.useNum || 0;
          });
        } else {
          this.formData.costAmount = 0;
          this.formData.useNum = 0;
        }
      } else if (this.formData.meterCategory == 'EXPEND_METER') {
        if (this.isNumber(this.formData.endNum) && this.isNumber(this.formData.startNum)) {
          getSumAmount({
            meterId: this.formData.meterId,
            startNum: this.formData.startNum,
            endNum: this.formData.endNum,
          }).then(({ data }) => {
            this.formData.useNum = data.useNum || 0;
          });
        } else {
          this.formData.useNum = 0;
        }
      }
    },
    /* 获取详情 */
    getDetail() {
      this.loading = true;
      getDetail({
        id: this.rowData.id,
      })
        .then(({ data }) => {
          this.formData = data;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    /* 保存 */
    doSave() {
      this.$refs.formRef.validate((valid) => {
        this.$refs.formRef.allDisabled = false; // avue-form表单验证后会导致表单项禁止编辑，需要重置此属性解除这个限制
        if (valid) {
          let fn = this.dialogType == 'add' ? add : update;
          let params = { ...this.formData };
          if (params.meterCategory == 'EXPEND_METER') {
            delete params.unitPrice;
          }
          fn(params, {
            showLoading: { text: '处理中...' },
          }).then(() => {
            this.$message.success('操作成功!');
            this.$emit('update');
          });
        }
      });
    },
    /* 取消 */
    doClose() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog-root {
  /* 给按钮的父元素加一个相对定位，方便按钮的布局 */
  position: relative;
  /* 内容容器 */
  .container {
    position: relative;
    box-sizing: border-box;
    width: 100%;
    max-height: 60vh;
    padding: 0 10px;
    overflow: scroll;
  }
  /* 按钮占位区域 */
  .placeholder {
    height: 50px;
  }
  /* 底部固定的按钮区域 */
  .btn {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    background: #fff;
  }
}
</style>
